module.exports = __webpack_public_path__ + "resources/img/img_ai_fashion2_m.b51f11c58c9ac4d03b639c3089dedefe.png";